import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../api';

const AdminMainMenu: React.FC = () => {
  const [menus, setMenus] = useState<any[]>([]);
  const [form, setForm] = useState({ name: '', icon: '', url: '', sub_menus: '', require_login: false });
  const [editId, setEditId] = useState<number | null>(null);
  const [editForm, setEditForm] = useState<any>(null);

  useEffect(() => { adminAPI.menus().then(res => setMenus(res.data)); }, []);

  const add = async () => {
    if (!form.name) { alert('메뉴명을 입력하세요.'); return; }
    const newMenus = [...menus, { ...form, order: menus.length }];
    try {
      await adminAPI.updateMenus(newMenus);
      const res = await adminAPI.menus();
      setMenus(res.data);
      setForm({ name: '', icon: '', url: '', sub_menus: '', require_login: false });
    } catch (e) { alert('저장 실패'); }
  };

  const del = async (id: number) => {
    if (!window.confirm('삭제하시겠습니까?')) return;
    const newMenus = menus.filter(m => m.id !== id);
    try { await adminAPI.updateMenus(newMenus); const res = await adminAPI.menus(); setMenus(res.data); } catch (e) {}
  };

  const startEdit = (m: any) => {
    setEditId(m.id);
    setEditForm({ name: m.name, icon: m.icon || '', url: m.url || '', sub_menus: m.sub_menus || '', require_login: m.require_login || false });
  };

  const cancelEdit = () => { setEditId(null); setEditForm(null); };

  const saveEdit = async () => {
    if (!editForm.name) { alert('메뉴명을 입력하세요.'); return; }
    const newMenus = menus.map(m => m.id === editId ? { ...m, ...editForm } : m);
    try {
      await adminAPI.updateMenus(newMenus);
      const res = await adminAPI.menus();
      setMenus(res.data);
      cancelEdit();
    } catch (e) { alert('저장 실패'); }
  };

  return (
    <div className="admin-page">
      <div className="admin-page-header">
        <div className="admin-page-title"><span className="icon">📱</span>메인 메뉴 관리</div>
      </div>

      {/* 추가 폼 */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-header">➕ 메뉴 추가</div>
        <div className="card-body">
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', alignItems: 'flex-end' }}>
            <div style={{ flex: '1 1 120px' }}>
              <label className="form-label">메뉴명</label>
              <input className="form-control" placeholder="메뉴 이름" value={form.name} onChange={e => setForm({...form, name: e.target.value})} />
            </div>
            <div style={{ flex: '0 0 70px' }}>
              <label className="form-label">아이콘</label>
              <input className="form-control" placeholder="📚" value={form.icon} onChange={e => setForm({...form, icon: e.target.value})} />
            </div>
            <div style={{ flex: '1 1 140px' }}>
              <label className="form-label">URL (내부: /board, 외부: https://...)</label>
              <input className="form-control" placeholder="/board 또는 https://..." value={form.url} onChange={e => setForm({...form, url: e.target.value})} />
            </div>
            <div style={{ flex: '1 1 200px' }}>
              <label className="form-label">서브메뉴 (쉼표 구분)</label>
              <input className="form-control" placeholder="서브1, 서브2, https://..." value={form.sub_menus} onChange={e => setForm({...form, sub_menus: e.target.value})} />
            </div>
            <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, cursor: 'pointer', paddingBottom: 2 }}>
              <input type="checkbox" checked={form.require_login} onChange={e => setForm({...form, require_login: e.target.checked})} />
              🔒 로그인 필수
            </label>
            <button className="btn btn-primary" onClick={add}>추가</button>
          </div>
        </div>
      </div>

      {/* 목록 */}
      <div className="card">
        <div className="card-header">📊 현재 메뉴 ({menus.length}개)</div>
        <div className="card-body" style={{ padding: 0 }}>
          <table className="table">
            <thead>
              <tr>
                <th style={{ width: 50 }}>아이콘</th>
                <th>메뉴명</th>
                <th>URL</th>
                <th>서브메뉴</th>
                <th style={{ width: 60 }}>로그인</th>
                <th style={{ width: 120 }}>관리</th>
              </tr>
            </thead>
            <tbody>
              {menus.map((m: any) => (
                <React.Fragment key={m.id}>
                  {/* 일반 행 */}
                  {editId !== m.id ? (
                    <tr>
                      <td style={{ textAlign: 'center', fontSize: 18 }}>{m.icon || '📌'}</td>
                      <td style={{ fontWeight: 600 }}>{m.name}</td>
                      <td style={{ color: 'var(--primary)', fontSize: 12 }}>{m.url || '-'}</td>
                      <td style={{ color: 'var(--text-muted)', fontSize: 12 }}>{m.sub_menus || '-'}</td>
                      <td style={{ textAlign: 'center' }}>{m.require_login ? '🔒' : '-'}</td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn-sm" style={{ background: '#f0f9ff', color: '#0369a1', border: '1px solid #bae6fd' }}
                            onClick={() => startEdit(m)}>✏️ 수정</button>
                          <button className="btn btn-danger btn-sm" onClick={() => del(m.id)}>삭제</button>
                        </div>
                      </td>
                    </tr>
                  ) : (
                    /* 수정 행 */
                    <tr style={{ background: '#fffbeb' }}>
                      <td>
                        <input className="form-control" placeholder="📚" value={editForm.icon}
                          onChange={e => setEditForm({...editForm, icon: e.target.value})}
                          style={{ width: 50, fontSize: 16, textAlign: 'center', padding: '4px' }} />
                      </td>
                      <td>
                        <input className="form-control" value={editForm.name}
                          onChange={e => setEditForm({...editForm, name: e.target.value})}
                          style={{ fontSize: 13 }} />
                      </td>
                      <td>
                        <input className="form-control" placeholder="/board 또는 https://..."
                          value={editForm.url}
                          onChange={e => setEditForm({...editForm, url: e.target.value})}
                          style={{ fontSize: 12 }} />
                      </td>
                      <td>
                        <input className="form-control" placeholder="서브1, 서브2"
                          value={editForm.sub_menus}
                          onChange={e => setEditForm({...editForm, sub_menus: e.target.value})}
                          style={{ fontSize: 12 }} />
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <input type="checkbox" checked={editForm.require_login}
                          onChange={e => setEditForm({...editForm, require_login: e.target.checked})} />
                      </td>
                      <td>
                        <div style={{ display: 'flex', gap: 4 }}>
                          <button className="btn btn-primary btn-sm" onClick={saveEdit}>💾 저장</button>
                          <button className="btn btn-ghost btn-sm" onClick={cancelEdit}>취소</button>
                        </div>
                      </td>
                    </tr>
                  )}
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default AdminMainMenu;
